import Vue from "vue";
import configs from "../configs";
import { stringify } from "query-string";

// const { get, post, delete: deletar, patch } = Vue.prototype.$http
const ip = configs.apiBase;

// ##################################################################### //
//                       ENDPOINTS DE SUBSTITUIÇÃO                       //
// ##################################################################### //
const getNotasDestaqueIcmsStInterestadual = (query) =>
  Vue.prototype.$http.get(
    `${ip}/icms/notas/icms/st/interestadual?${stringify(query)}`,
  );

// ##################################################################### //
//                       NOVOS ENDPOINTS DE SUBSTITUIÇÃO                 //
// ##################################################################### //
const produtosSubstituicaoEmpresa = ({ idEmpresa, ...rest }) => {
  // ?idEmpresa=12&dtInicial=2019-02-01&dtFinal=2019-02-28&limit=10&offset=0&fts=&hashKey=
  return Vue.prototype.$http.get(
    `${ip}/icms/produtos/substituicao/empresa/${idEmpresa}?${stringify(rest)}`,
  );
};

const produtosSubstituicaoEmpresaDelete = ({ idEmpresa, ...rest }) => {
  // { item, idEmpresa, codItem, hashKey, _idx }
  return Vue.prototype.$http.deletar(
    `${ip}/icms/empresa/${idEmpresa}/produto/substituicao?${stringify(rest)}`,
  );
};

const produtosSubstituicaoDeleteOcultosEmpresa = ({ idEmpresa, ...rest }) => {
  // ?codItem=&descrItem=
  return Vue.prototype.$http.deletar(
    `${ip}/icms/produtos/substituicao/empresa/${idEmpresa}/ocultos?${stringify(rest)}`,
  );
};

const produtosSubstituicao = (query) => {
  // vigencia=2019-11-01&limit=10&offset=0&fts=
  return Vue.prototype.$http.get(
    `${ip}/icms/produtos/substituicao?${stringify(query)}`,
  );
};

// ##################################################################### //
//                    ENDPOINTS DE ESTIMATIVA MEDIA                      //
// ##################################################################### //
const getEstimativaProdutos = (query) =>
  Vue.prototype.$http.get(
    `${ip}/icms/estimativa/media/item?${stringify(query)}`,
  );
const saveEstimativaProdutos = (query) =>
  Vue.prototype.$http.post(`${ip}/icms/estimativa/media/item`, query);

const deleteNotasInseridas = (query) =>
  Vue.prototype.$http.deletar(
    `${ip}/icms/estimativa/media/item?${stringify(query)}`,
  );

// ##################################################################### //
//                 ENDPOINTS DE ESTIMATIVA RELATORIOS                    //
// ##################################################################### //
const getNotasSemSubstituicao = (query) =>
  Vue.prototype.$http.get(
    `${ip}/icms/estimativa/media/relatorio?${stringify(query)}`,
  );

const getNotasComSubstituicao = (query) =>
  Vue.prototype.$http.get(
    `${ip}/icms/notas/com/substituicao?${stringify(query)}`,
  );

// ##################################################################### //
//                       ENDPOINTS DE APURAÇÃO RESUMO                    //
// ##################################################################### //
const getResumoAuditoria = (query) =>
  Vue.prototype.$http.get(
    `${ip}/icms/apuracao/resumo/nota?${stringify(query)}`,
  );
const getEstimativaTotais = (idNfe) =>
  Vue.prototype.$http.get(
    `${ip}/icms/apuracao/resumo/nota/${idNfe}/totalizador`,
  );
const deleteResumo = (query) =>
  Vue.prototype.$http.deletar(
    `${ip}/icms/apuracao/resumo/nota?${stringify(query)}`,
  );
const getResumoNotaFromRegime = (query) =>
  Vue.prototype.$http.get(`${ip}/icms/apuracao/nota?${stringify(query)}`);

// { convenio, anexo, item, ncm, cpfCnpj, cProd, operacao, _idx, hashKey }
const deleteConvenioFornecedor = (query) =>
  Vue.prototype.$http.deletar(
    `${ip}/icms/convenio/fornecedor?${stringify(query)}`,
  );

// ##################################################################### //
//                       ENDPOINTS COMPLEMENTARES                        //
// ##################################################################### //

const getNotas = (query) =>
  Vue.prototype.$http.get(
    `${ip}/icms/apuracao/calculo/nota?${stringify(query)}`,
  );

const getNotasFaltantes = (query) =>
  Vue.prototype.$http.get(
    `${ip}/icms/apuracao/notas/faltantes/${query.idEmpresa}?${stringify(query)}`,
  );

// { idEmpresa, dtFinal }
const getCodReceita = (query) =>
  Vue.prototype.$http.get(
    `${ip}/icms/apuracao/codigo/receita?${stringify(query)}`,
  );

const getNaoApuradas = ({ idEmpresa, ...rest }) =>
  Vue.prototype.$http.get(
    `${ip}/icms/apuracao/notas/nao/apuradas/${idEmpresa}?${stringify(rest)}`,
  );

const postEstimativaTotais = (query) =>
  Vue.prototype.$http.post(`${ip}/icms/apuracao/nota`, query);

const patchEstimativaTotais = (query) =>
  Vue.prototype.$http.patch(`${ip}/icms/apuracao/nota`, query);

const postGuiaNoSped = (query) =>
  Vue.prototype.$http.post(`${ip}/icms/apuracao/efd`, query);

const postTranferirOutroSped = (query) =>
  Vue.prototype.$http.post(`${ip}/icms/apuracao/transferir/dfe`, query);

const autoApurar = (query) =>
  Vue.prototype.$http.post(`http://172.16.10.34/decisiontree/apurar`, query);

const getStatusApuracao = (query) =>
  Vue.prototype.$http.get(
    `http://172.16.10.34/decisiontree/apurar/response?${stringify(query)}`,
  );

const GetResumoIcmsDominio = ({ idEmpresa, date }) =>
  Vue.prototype.$http.get(
    `${ip}/icms/resumo/dominio/empresa/${idEmpresa}?${stringify(date)}`,
  );

const GetDifalConsumo = ({ idEmpresa, dtInicial, dtFinal }) =>
  Vue.prototype.$http.get(
    `${ip}/icms/consumo/difal/empresa/${idEmpresa}?${stringify({ dtInicial, dtFinal })}`,
  );

// ------------ //

const removeReferenceConvenio = async ({
  idEmpresa,
  cpfCnpj,
  cProd,
  xProd,
}) => {
  return Vue.prototype.$http.delete(
    `${ip}/icms/delete/reference/convenio?idEmpresa=${idEmpresa}&cpfCnpj=${cpfCnpj}&cProd=${cProd}&xProd=${xProd}`,
  );
};

const referenceConvenio = async ({
  idEmpresa,
  cpfCnpj,
  cProd,
  xProd,
  anexo,
  item,
}) => {
  const payload = { idEmpresa, cpfCnpj, cProd, xProd, anexo, item };
  return Vue.prototype.$http.post(`${ip}/icms/reference/convenio`, payload);
};

const retrieveSubstituicao = async ({ ncmCestDesc, vigencia }) => {
  const query = stringify({ ncmCestDesc, vigencia });
  return Vue.prototype.$http.get(
    `${ip}/icms/produtos/substituicao/ncm?${query}`,
  );
};

const retrieveIsento = async ({ ncmCestDesc, vigencia }) => {
  const query = stringify({ ncmCestDesc, vigencia });
  return Vue.prototype.$http.get(`${ip}/icms/produtos/isentos/ncm?${query}`);
};

const retrieveConvenio = async ({ ncmCestDesc, vigencia }) => {
  const query = stringify({ ncmCestDesc, vigencia });
  return Vue.prototype.$http.get(
    `${ip}/icms/produtos/ricms/convenio/ncm?${query}`,
  );
};

const retrieveReducaoBc = async ({ ncmCestDesc, vigencia }) => {
  const query = stringify({ ncmCestDesc, vigencia });
  return Vue.prototype.$http.get(
    `${ip}/icms/produtos/ricms/reducao/ncm?${query}`,
  );
};

const getDifferentialAliquotNotes = async (data) => {
  return Vue.prototype.$http.post(
    `${ip}/icms/differential/aliquot/notes`,
    data,
  );
};

const getDifferentialAliquotItems = async ({
  idEmpresa,
  idNfe,
  aliqOrigem,
  pOutro,
}) => {
  return Vue.prototype.$http.get(
    `${ip}/icms/differential/aliquot/items?${stringify({ idEmpresa, idNfe, aliqOrigem, pOutro })}`,
  );
};

const getSubstituicao = async (fts, limit) => {
  // icms/produtos/substituicao?fts=33043000|33043021
  return Vue.prototype.$http.get(
    `${ip}/icms/produtos/substituicao?fts=${fts}&limit=${limit}`,
  );
};

const getIsentosByNcm = async (query) => {
  // icms/produtos/isentos?fts=33043000|33043021
  return Vue.prototype.$http.get(`${ip}/icms/produtos/isentos?fts=${query}`);
};

const insertDifferentialAliquotReference = async (payload) =>
  Vue.prototype.$http.post(
    `${ip}/icms/differential/aliquot/insert/reference`,
    payload,
  );

const deleteDifferentialAliquotReference = async ({
  idEmpresa,
  cpfCnpj,
  cProd,
  xProd,
}) => {
  return Vue.prototype.$http.delete(
    `${ip}/icms/differential/aliquot/delete/reference?${stringify({
      idEmpresa,
      cpfCnpj,
      cProd,
      xProd,
    })}`,
  );
};

const genaratePdfDifalGuia = async ({ keyNote, ...query }) => {
  return Vue.prototype.$http.post(
    `${ip}/icms/difal/guias?${stringify(query)}`,
    { keyNote },
    {
      responseType: "blob",
    },
  );
};

const consultaEnergia = async (query) => {
  return Vue.prototype.$http.get(`${ip}/icms/energia/consulta?${stringify(query)}`);
};

const updateEnergia = async (body) => {
  return Vue.prototype.$http.patch(`${ip}/icms/energia/update`, body);
};

export default {
  // Novos Endpoints Substituicao
  produtosSubstituicaoDeleteOcultosEmpresa,
  produtosSubstituicaoEmpresaDelete,
  produtosSubstituicaoEmpresa,
  produtosSubstituicao,
  getNotasDestaqueIcmsStInterestadual,
  //  Funpobreza
  getNotas,
  deleteResumo,
  getCodReceita,
  postGuiaNoSped,
  getResumoAuditoria,
  getEstimativaTotais,
  getResumoNotaFromRegime,
  deleteNotasInseridas,
  postEstimativaTotais,
  patchEstimativaTotais,
  getEstimativaProdutos,
  saveEstimativaProdutos,
  getNotasSemSubstituicao,
  getNotasComSubstituicao,
  getNaoApuradas,
  postTranferirOutroSped,
  getNotasFaltantes,
  //
  autoApurar,
  getStatusApuracao,

  // Convenio
  deleteConvenioFornecedor,

  // Resumo Icms Dominio
  GetResumoIcmsDominio,

  // Consumo
  GetDifalConsumo,
  removeReferenceConvenio,
  referenceConvenio,
  retrieveSubstituicao,
  retrieveIsento,
  retrieveConvenio,
  getDifferentialAliquotNotes,
  getDifferentialAliquotItems,
  getSubstituicao,
  getIsentosByNcm,
  insertDifferentialAliquotReference,
  deleteDifferentialAliquotReference,
  genaratePdfDifalGuia,
  retrieveReducaoBc,
  consultaEnergia,
  updateEnergia
};
